import React, { memo } from 'react'

import {
  ArrowLeft,
  ArrowRight,
  Icon,
  Button,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, func } from 'prop-types'

function NavigationButton({ icon, customClass, onClick, ariaLabel }) {
  return (
    <Button
      variant="only-icon"
      size="small"
      customClass={customClass}
      onClick={onClick}
      icon={<Icon svgComponent={icon === 'ArrowLeft' ? ArrowLeft : ArrowRight} />}
      aria-label={ariaLabel}
    />
  )
}

NavigationButton.propTypes = {
  icon: string.isRequired,
  customClass: string.isRequired,
  onClick: func,
  ariaLabel: string.isRequired,
}

export default memo(NavigationButton)
